import "./End.css";

const End = () => {
  return (
    <div className="portfolio-appreciation-section">
      <h1 className="portfolio-appreciation-header">A Sincere Thank You!</h1>
      <div className="portfolio-appreciation-text">
        You made it to the end of my portfolio. Thank you so much for taking the
        time out of your day to consider me! Please reach out to me via email
        for any opportunities.
      </div>
    </div>
  );
};

export default End;
